import { INITIATIVE_COMPUTED_FIELDS, InitiativeFieldType } from '@/constants/initiative'
import getCustomFieldCellWidth from '@/utils/initiative/getCustomFieldCellWidth'
import showAPIError from '@/utils/showAPIError'
import { SYSTEM_FIELDS } from '../constants/initiative'

/**
 * This exposed data points related to Initiative's display fields
 *
 * Note: this mixin requires component to have orgId and teamId
 */
export default {
  computed: {
    orgCFs() {
      return this.$store.state.orgCustomFields[this.orgId] || []
    },
    fieldsToDisplay() {
      let customFields = []
      let enabledCustomFields = []
      if (this.projectId) {
        customFields = this.$store.getters
          .initiativeDisplayFieldsByProjectId(this.projectId)
          ?.filter(field => !!field.customFieldDefinitionId)
        enabledCustomFields = this.$store.getters.initiativeEnabledCustomFieldsByProjectId(
          this.projectId
        )
      } else {
        customFields = this.$store.getters
          .initiativeDisplayFieldsByTeamId(this.teamId)
          ?.filter(field => !!field.customFieldDefinitionId)
        enabledCustomFields = this.$store.getters.initiativeEnabledCustomFieldsByTeamId(this.teamId)
      }

      customFields = (customFields || [])
        .map(({ customFieldDefinitionId, id }) => ({
          ...this.orgCFs.find(field => field.id === customFieldDefinitionId),
          displayFieldId: id,
          enabledFieldId: enabledCustomFields?.find(field => field.id === customFieldDefinitionId)
            ?.enabledFieldId
        }))
        .filter(Boolean)
        .map(field => ({
          ...field,
          title: field.name,
          width: getCustomFieldCellWidth(field),
          fieldType: InitiativeFieldType.CUSTOM_FIELD
        }))
      return [...this.standardFields, ...customFields]
    },
    computedFields() {
      let config = this.standardFieldsList
      return (config || []).filter(fieldName =>
        INITIATIVE_COMPUTED_FIELDS.find(field => field.name === fieldName)
      )
    },
    standardFields() {
      let config = this.standardFieldsList
      const fields = (config || []).map(({ standardFieldName, id }) => ({
        ...SYSTEM_FIELDS.find(field => field.name === standardFieldName),
        displayFieldId: id
      }))
      return fields.filter(x => x.name !== 'title')
    },
    standardFieldsList() {
      if (this.projectId) {
        return this.$store.getters
          .initiativeDisplayFieldsByProjectId(this.projectId)
          ?.filter(field => !!field.standardFieldName)
      } else {
        return this.$store.getters
          .initiativeDisplayFieldsByTeamId(this.teamId)
          ?.filter(field => !!field.standardFieldName)
      }
    }
  },
  methods: {
    async fetchDisplayFields() {
      try {
        return this.$store.dispatch('getDisplayInitiativeFields', {
          orgId: this.orgId,
          teamId: this.teamId,
          projectId: this.projectId
        })
      } catch (e) {
        showAPIError(e)
      }
    },
    async fetchDisplayFieldIfNotPresent() {
      if (this.standardFieldsList) return
      else {
        await this.fetchDisplayFields()
      }
    }
  }
}
